<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';
import DimensionInput from '@/components/UI/DimensionInput.vue';
import { addSizeToDataLayer } from '@/functions/analytics';
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";

const store = useStore();
const { isCutout, action, prefix } = defineProps<Props>();

const dimensions = computed(() => store.getters.getMeasurements( 'half-circle', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const diameter = computed({
	get: () => dimensions.value.diameter,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "diameter",
			value: value,
		});
	},
});
</script>
<template>
	<shape-input-fields-wrapper>
		<dimension-input
			inputRef="half-circle-diameter"
			:id="`${prefix}measurements-half-circle-diameter`"
			:name="`${prefix}measurements[dimensions][diameter]`"
			unit="cm"
			:label="dimensionLabel('diameter', 'half-circle')"
			:instructions="isCutout ? '' : dimensionMaxLabel('diameter')"
			:invalid="!isDimensionValid(`${prefix}half-circle-diameter`)"
			:onBlur="() => addSizeToDataLayer('diameter', +diameter, 'half-circle')"
			v-model="diameter"
		/>
	</shape-input-fields-wrapper>
</template>
